import React from 'react';
import RecipeVegetarian from '../../components/RecipeVegetarian';

const Vegetarian = () => {
  return (
    <div className="home-page">
      <RecipeVegetarian />
    </div>
  );
};

export default Vegetarian;